const LogoContainer = () => {
  return (
    <div className='logoContainer'>
      <img className='logoImg' src={process.env.PUBLIC_URL + '/assets/logo-main.jpg'} alt='logo' />
    </div>
  )
}

export default LogoContainer;